export function emitGroqToast(label = "Calling Groq…") {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(
      new CustomEvent("groq-call", {
        detail: { label },
      })
    );
  } catch {
    // ignore
  }
}
